import { useActiveLang } from "./use-active-lang";
import { useLangStrings } from "./use-lang-strings";
export var useActiveLangStrings = function useActiveLangStrings() {
  var lang = useActiveLang();
  var strings = useLangStrings();
  return strings[lang.iso] || {};
};